export const ADMIN_URL = '/administrators';
export const APPLICATIONS_URL = '/applications';
export const APP_CREATE_URL = '/create-application';
export const ATTRIBUTES_URL = '/attributes';

export const DEBUG_URL = '/debug';
export const DIRECTORIES_URL = '/directories';
export const DYNAMIC_PAGES_URL = '/pages';

export const FEATURES_URL = '/feature-management';

export const GENERAL_URL = '/general';

export const HOME_URL = '/admin';
export const HOMEPAGE_URL = '/homepage';

export const PERSON_PROFILE_URL = '/person-profiles';

export const SOURCE_CREATE_URL = '/create-source';
export const SOURCE_URL = '/source';

export const USER_URL = '/user';
export const USERS_URL = '/users';

export const WIDGETS_URL = '/widgets';
export const WIDGETS_LAYOUT_URL = '/widgets-layout';

export const ROLES_AND_PERMISSIONS_URL = '/roles-and-permissions';
export const ROLES_URL = '/roles';
export const ROLE_CREATE_URL = '/create-role';
